"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Appointment = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var nucalm_1 = require("../../model/nucalm");
var service_1 = require("../../../library/base/service");
var Appointment = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Appointment, _super);
    function Appointment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取已预约记录';
        _this.code = '101200';
        _this.desc = '获取已预约记录';
        _this.requestParams = new nucalm_1.NucalmRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Appointment;
}(service_1.BaseService));
exports.Appointment = Appointment;
//# sourceMappingURL=appointment.js.map